const ServiceLocalization = {
    listing: {
        filter: {
            all: 'All',
            publishStatus: 'Publish status',
            serviceType: 'Service type',
            search: 'Search the product',
            selectCountry: 'Select country',
            country: 'Country',
        },
    },
    searchPlaceholder: 'Search add-ons',
    addons: 'Add-ons',
    columnSettings: 'Column settings',
    newAddon: 'New add-on',
    emptyMessage: 'Please select a vendor to show it\'s Add-ons.',
    deleteSelected: 'Delete Selected',
}

export default ServiceLocalization;